import React from "react";
import Sidebar from "./Dashboard/Sidebar";
import { Route, Routes } from 'react-router-dom';
import Review from "./Dashboard/Review";
import Helpdesk from "./Dashboard/Helpdesk";
import Profile from "./Dashboard/Profile";
const Dashboard = ({title}) => {

  return (
    <div className="bg-white text-black h-screen">
      <Sidebar />
      <Routes>
        <Route path="helpdesk" element={<Helpdesk title="Support | ClickStar"/>} />
        <Route path="profile" element={<Profile title="Password | ClickStar"/>} />
        <Route path="*" element={<Review title="Reviews | ClickStar"/>} />
      </Routes>
    </div>
  );
};

export default Dashboard;
